<script setup lang="ts">
defineProps<{
  txt: string | None
  sub?: string | None
  red?: boolean | None
  grey?: boolean | None
  black?: boolean | None
  sun?: boolean | None
}>()
</script>

<template>
  <span class="_lh1 _br9 _inline _hidden _wcont _hcont _wrap" :class="[$style.msg, { red, grey, sun, black }, !$slots.default && !sub && $style.txt]">
    <slot name="left" />
    <span v-if="txt" class="_relative _pr1 _pl1 _fs08 _fw-xl _ls-xs" :class="$style.txt2">{{ txt }}</span>
    <small v-if="sub" class="_fw-l _pl08 _pr08 _fs08 _ls-xs" :class="$style.small">{{ sub }}</small>
    <slot />
  </span>
</template>

<style module>
.a {
  composes: global(_flexline);
  align-items: center;
}
.msg {
  composes: a;

  --fill: var(--blue3);
  --col: hsl(222, 60%, 10%);
  --col2: var(--bg);
  border: 1px solid var(--fill);
  color: var(--col);
  min-height: 18px;
}
.txt {
  background: var(--fill);
  color: var(--col2);
  z-index: 1;
  word-spacing: 0;
}
.txt2 {
  composes: a;
  composes: global(_lh1);
  composes: txt;
  border-radius: 0 99px 99px 0;
  min-height: 17px;
}
.msg:global(.red) {
  --col: var(--red);
  --fill: linear-gradient(10deg, var(--red), hsl(345deg, 100%, 50%));
  border: 1px solid hsl(345.3, 94.7%, 44.7%);
}
.msg:global(.sun) {
  --col: hsl(37deg 100% 6%);
  --fill: hsl(37deg 100% 92%);
  --col2: hsl(37deg 100% 6%);
}
.msg:global(.grey) {
  --col: hsl(216deg 5% 6%);
  --fill: hsl(216deg 5% 95%);
  --col2: hsl(216deg 5% 30%);
}
.msg:global(.black) {
  --col: var(--black);
  --fill: var(--black);
  --col2: var(--bg);
}
</style>
